<div class="service-carousel-item">
  <img [ngSrc]="serviceCarouselItem.url" [alt]="serviceCarouselItem.altText" fill />
  <a [routerLink]="serviceCarouselItem.link" (click)="onClickService(serviceCarouselItem)">
    <span class="text-b4-m-500 text-xl-b1-s-500">{{ this.serviceCarouselItem.buttonText }}</span>
  </a>
</div>
